import { SCREENS } from '@core/assistant/interfaces';
import { debugTagName } from '@core/assistant/constants';

export const globals = {
  visualizerInstance: undefined as any,
  activeScreenGlob: SCREENS.DEFAULT as SCREENS,
  isMutedGlob: false,
  currentRegion: '',
  assistantGain: 1,
  assistantPlaybackRate: 1,
  // Module-level (not component state) so the one-time landing greet survives
  // the assistant Button being unmounted/remounted — e.g. HomeBottomBar moves
  // it between JSX slots when isHideAllExceptTopBar toggles, which would
  // otherwise reset a local ref and let a later `scripts` refetch replay it.
  hasGreetedLandingGlob: false,
  // Set by stopAssistantAudio() when the event page is torn down. An in-flight
  // Polly fetch (generatePollyAudio) started before teardown resolves after
  // the AssistantProvider tree has unmounted — its own stale-request checks
  // (audioPlaybackIdRef, openRef) live in that unmounted hook's closure and
  // never learn about the teardown, so onGenerateAudio must consult this
  // module-level flag as a last line of defense before starting playback.
  // Reset to false on the next AssistantProvider mount (Provider.tsx).
  assistantTornDown: false,
};

export const getCurrentRegion = (): string => {
  let currentArea = globals.currentRegion;
  if (!globals.currentRegion && debugTagName) {
    currentArea = debugTagName;
  }
  return currentArea;
};

/**
 * Stops any assistant audio currently playing, releases its AudioContext,
 * and marks the assistant as torn down so any Polly fetch already in flight
 * discards its result instead of starting new playback once it resolves.
 *
 * `globals.visualizerInstance` is module-level state that outlives the
 * `AssistantProvider` React tree (see the `hasGreetedLandingGlob` comment
 * above), so unmounting that tree does not, by itself, stop audio that is
 * mid-playback, nor does it prevent an in-flight fetch from resurrecting
 * playback afterward. Callers that tear down the whole event page (leaving
 * the event, back button, etc.) must call this directly instead of relying
 * on component unmount.
 */
export const stopAssistantAudio = (): void => {
  try {
    globals.visualizerInstance?.stopAudio?.();
  } catch {
    // visualizerInstance may not be initialized, or already stopped
  }
  globals.visualizerInstance = undefined;
  globals.assistantTornDown = true;
};
